import React, {Dispatch, SetStateAction} from 'react';
import {Col} from 'antd';
import {FormatCourierDto, FormatShippingCourierDto} from "@jnext/ts-axios-formatdigitalcollection";
import {JSelect, OptionDto} from "../JSelect";

export type JCourierSelectProps= {
    label?:string;
    placeholder?: string;
    couriers: FormatCourierDto[] | undefined;
    courierChoice: FormatShippingCourierDto | undefined;
    setCourierChoice: Dispatch<SetStateAction<FormatShippingCourierDto | undefined>>
};

export const JCourierSelect: React.FC<JCourierSelectProps> = (props) => {

    const getCourierOptionDto = () => {
        if(props?.couriers && props?.couriers?.length > 0){
            return props?.couriers?.map(el =>
                ({
                    id: el.externalId,
                    label: el.description,
                    option: el?.partners?.[0]?.flScheduledDelivery
                })) as OptionDto[];
        }
        return [{
            id: 0,
            label: 'no element',
        }]
    }


        return(
            <div className={'courier_container'}>
                <Col xs={24} md={18} span={24}>
                    <JSelect
                        defaultValue={props?.courierChoice?.courierExternalId}
                        value={props?.courierChoice?.courierExternalId}
                        label={props?.label}
                        onChange={(externalId) => {
                            props?.setCourierChoice({
                                courierExternalId: externalId as string,
                                flDeliveryScheduled: getCourierOptionDto()?.find(c => c.id === externalId)?.option
                            })
                        }}
                        options={getCourierOptionDto()}
                        placeholder={props?.placeholder}
                    />
                </Col>
            </div>
        )
};
